import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { IEquipment, IRegistration, IRegistrationInfo } from '@services/registrations/registrations.models';

import { DialogService } from '@services/dialog/';
import { RegistrationsService } from '@services/registrations';

import { TransferBikeComponent } from './../transfer-bike/transfer-bike.component';

@Component({
	selector: 'app-view-bike-details',
	templateUrl: './view-bike-details.component.html',
	styleUrls: ['./view-bike-details.component.scss']
})
export class ViewBikeDetailsComponent implements OnInit {

	public bike: IEquipment;
	public bikeDetails = [];
	public bikeHasActiveTransferRequests = true;
	public registrationDetails = [];
	public transferHistory = [];
	public dataReady = false;

	constructor(
		@Inject(MAT_DIALOG_DATA) public dialogData,
		private dialogRef: MatDialogRef<ViewBikeDetailsComponent>,
		private dialogService: DialogService,
		public registrationsService: RegistrationsService
	) { }

	ngOnInit(): void {
		console.log(this.dialogData['bike']);

		if (this.dialogData['bike']) {
			this.loadBikeDetails(this.dialogData['bike']);
		} else if (this.dialogData['id'] || this.dialogData['bikeUuid']) { // TODO: for some calls the API has this id.
			this.registrationsService.bikesById(
				this.dialogData['id']
			).subscribe((res: IEquipment) => {
				this.loadBikeDetails(res);
			});
		} else if (this.dialogData['serialNumber']) {
			this.registrationsService.bikesBySerialNumber(
				this.dialogData['serialNumber']
			).subscribe((res: IEquipment[]) => {
				this.loadBikeDetails(res[0]);
			});
		}
	}

	loadBikeDetails(bike): void {
		this.bike = bike;

		// TODO: some values not available yet
		this.bikeDetails = [
			{ value: bike['bikeUuid'], label: 'ID' },
			{ value: bike['serialNumber'], label: 'Serial Number' },
			{ value: bike['itemNumber'], label: 'Item Number' },
			//{ value: 'SpecializedBike', label: 'Bike Type' },
			//{ value: 'Specialized', label: 'Manufacturer' },
			{ value: bike['isRegistered'], label: 'Registered?' },
			//{ value: 'HOTROCK', label: 'Family' },
			{ value: bike['model'], label: 'Model' },
			{ value: bike['year'], label: 'Year' },
			{ value: bike['isEBike'], label: 'E-Bike?' },
			{ value: bike['isLockSupported'], label: 'Lock Supported?' },
			//{ value: 'false', label: 'Ownership Verified?' },
			//{ value: 'false', label: 'Allowed to Lock?' }
		];

		if (bike['isRegistered']) {
			this.loadUserDetails();
			this.loadRegistrationDetails();
			this.loadTransferHistory(bike['bikeUuid']);
		}
	}

	loadUserDetails(): void {
		this.registrationsService.getRegistrationInfo(
			this.bike['bikeUuid']
		).subscribe((res: IRegistrationInfo) => {
			const bikes = res['adminBikes'];

			for (let i = 0; i < bikes.length; i++) {
				let bike = bikes[i];

				if (this.bike['bikeUuid'] === bike['bikeId']) {
					this.registrationDetails.push({ value: bike['userId'], label: 'User ID (internal)' });
					// this.registrationDetails.push({ value: bike['email'], label: 'Emain' }); // TODO: When the api is ready

					break;
				}
			}
		});
	}

	loadRegistrationDetails(): void {
		this.registrationsService.getRegistrations().subscribe((res: IRegistration[]) => {
			const registrations = res['allBikes'];

			for (let i = 0; i < registrations.length; i++) {
				let registration = registrations[i];

				if (this.bike['bikeUuid'] === registration['bikeUuid']) {
					this.registrationDetails.push({ value: registration['purchaseDate'], label: 'Purchase Date'});
					this.registrationDetails.push({ value: registration['isVerifiedOwnership'], label: 'Owner Verified'});

					break;
				}
			}
		});
	}

	loadTransferHistory(bikeId: string): void {
		this.registrationsService.fetchTransferHistoryForBike(bikeId).subscribe((res: any) => {
			this.transferHistory = res;
			this.bikeHasActiveTransferRequests = this.bikeHasActiveTRs(res);
			this.dataReady = true;
		});
	}

	bikeHasActiveTRs(transfers: any[]): boolean {
		for (let i = 0; i < transfers.length; i++) {
			if (!transfers[i]['accepted'] && !transfers[i]['denied']) {
				return true;
			}
		}

		return false;
	}

	close(): void {
		this.dialogRef.close();
	}

	registerBike(): void {
		// this.registrationsService.registerBike(this.dialogData['bikeid']).subscribe((res: IEquipment) => {
		// 	// toast message
		// });
	}

	deleteCurrentRegistration(): void {
		// this.registrationsService.deleteCurrentRegistration(this.dialogData['bikeid']).subscribe((res: IEquipment) => {
		// 	// toast message
		// });
	}

	transferBike(): void {
		console.log('ViewBikeDetailsComponent - transferBike: ', this.dialogData['bike']);
		this.dialogService.open(TransferBikeComponent, {
			data: {
				bike: this.bike,
				callback: (requestId: string) => {}
			}
		});
	}
}
